export const ALIGNMENT_PADDING = 10;
